const BulkEdit = require('./BulkEdit');
const TimeShift = require('./TimeShift');
const Duplicate = require('./Duplicate');

module.exports = angular.module('backstage.controllers.events.bulk', [])
    .controller('BulkEdit', BulkEdit)
    .controller('TimeShift', TimeShift)
    .controller('Duplicate', Duplicate)
    .name;
